module.exports = __webpack_public_path__ + "static/media/CA-logo-horizontal-white.6cd32431.png";